import DefaultLayout from '../../layout/DefaultLayout';
import InventoryMovementTableSection from '../../components/inventory/movement/InventoryMovementTableSection';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const InventoryMovements = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <InventoryMovementTableSection />
    </DefaultLayout>
  );
};

export default InventoryMovements;
